import { FC } from 'react'

import { clsx } from 'clsx'

import { useBackgroundContext } from '../BackgroundContext/index.js'
import { FormControlLabelProps } from '../FormControl/types.js'

export const Label: FC<FormControlLabelProps> = props => {
  const { children, className, secondaryLabel, tertiaryLabel, ...rest } = props

  const { backgroundType } = useBackgroundContext()

  const textClsx = [
    backgroundType === 'main' && 'text-content-on-background',
    backgroundType === 'surface' && 'text-content',
    backgroundType === 'secondary' && 'text-content-on-topbar',
  ]

  const label = (
    <label className={clsx('block font-medium', textClsx, className)} {...rest}>
      {children}
    </label>
  )

  if (!!secondaryLabel || !!tertiaryLabel) {
    return (
      <div className="flex space-s-2 items-center justify-between">
        {!secondaryLabel ? (
          label
        ) : (
          <div className="flex space-s-1 items-center">
            {label}
            <div>{secondaryLabel}</div>
          </div>
        )}
        <div>{tertiaryLabel}</div>
      </div>
    )
  }

  return label
}
